import React from 'react'
import { Box, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useLocation } from 'react-router-dom'
import { AnimatedPage } from '../animations/MotionContainers'
import { useSuiteSession } from '../../context/SuiteSessionContext'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { UnsavedChangesContext } from '../../context/UnsavedChangesContext'

export const AppShell = ({ children }) => {
  const theme = useTheme()
  const isTabletShell = useMediaQuery(theme.breakpoints.down('lg'))
  const [sidebarOpen, setSidebarOpen] = React.useState(!isTabletShell)
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false)
  const location = useLocation()
  const { logout, session, status, usingFallback } = useSuiteSession()
  const { confirmDiscard } = React.useContext(UnsavedChangesContext)

  React.useEffect(() => {
    setSidebarOpen(!isTabletShell)
  }, [isTabletShell])

  React.useEffect(() => {
    if (isTabletShell) setSidebarOpen(false)
  }, [isTabletShell, location.pathname])

  const handleTopbarMenuClick = () => {
    if (isTabletShell) {
      setSidebarOpen((open) => !open)
      return
    }

    setSidebarCollapsed((collapsed) => !collapsed)
  }

  return (
    <Box className="suite-shell">
      <Sidebar
        open={sidebarOpen}
        mobile={isTabletShell}
        collapsed={sidebarCollapsed}
        onClose={() => setSidebarOpen(false)}
        onToggleCollapse={() => setSidebarCollapsed((collapsed) => !collapsed)}
        session={session}
      />

      <Box className="suite-main">
        <Topbar
          onMenuClick={handleTopbarMenuClick}
          sidebarCollapsed={sidebarCollapsed}
          sidebarOpen={sidebarOpen}
          mobile={isTabletShell}
          session={session}
          sessionStatus={status}
          usingFallback={usingFallback}
          onLogout={() => { if (confirmDiscard()) logout() }}
        />

        <Box component="main" className="suite-content">
          <AnimatedPage>{children}</AnimatedPage>
        </Box>
      </Box>
    </Box>
  )
}
